import React, { useEffect, useReducer } from 'react';
import { Route, Switch, HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';
import 'scss/style.scss';

import { AuthContext } from 'context/AuthContext';

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
// const Register = React.lazy(() => import('./views/pages/register/Register'));
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/ForgotPassword'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const initialState = {
  isAuthenticated: false,
  user: null,
  access_token: null,
  refresh_token: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("access_token", action.payload.access_token);
      localStorage.setItem("refresh_token", action.payload.refresh_token);
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        access_token: action.payload.access_token,
        refresh_token: action.payload.refresh_token
      };
    case "LOGOUT":
      localStorage.removeItem("user");
      localStorage.removeItem("expiryDate");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        access_token: null,
        refresh_token: null
      };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {

    const user = JSON.parse(localStorage.getItem("user"));
    const expiryDate = localStorage.getItem("expiryDate");
    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");

    if (!user || !expiryDate || !refresh_token || !access_token) {
      dispatch({ type: "LOGOUT" });
      return;
    }

    if (new Date(expiryDate) <= new Date()) {
      dispatch({ type: "LOGOUT" });
      return;
    }

    dispatch({ type: "LOGIN", payload: { user, access_token, refresh_token, expiryDate } });

  }, []);

  let routes = (
    <Switch>
      <Route exact path="/" name="Login Page" render={props => <Login {...props} />} />
      <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
      {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} /> */}
      <Route exact path="/forgot-password" name="Login Page" render={props => <ForgotPassword {...props} />} />
      <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
      <Route exact name="Page 404" render={props => <Page404 {...props} />} />
    </Switch>
  );

  if (state.isAuthenticated) {

    routes = (
      <Switch>
        <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
        <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
        <Route exact name="Page 404" render={props => <Page404 {...props} />} />
      </Switch>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <ToastContainer />
      <HashRouter>
        <React.Suspense fallback={loading}>
          {routes}
        </React.Suspense>
      </HashRouter>
    </AuthContext.Provider>
  );
}

export default App;
